var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx } from "react/jsx-runtime";
import { useEffect, useState, useRef } from 'react';
import gsap from 'gsap';
import Carousel from './Micros/Carousel';
import './CardCarousel.scss';
import SwiperCore, { Virtual, Navigation } from 'swiper';
SwiperCore.use([Virtual, Navigation]);
import '../../lib/styles/swiper.scss';
import card0 from '../../assets/images/twoCards/MaskGroup.png';
import card1 from '../../assets/images/twoCards/MaskGroup-2.png';
var defaultProps = {
    data: {
        title: 'Delve into the Intelligent Financial Life™',
        resourceCardList: [
            {
                id: 'card-0',
                image: card0,
                type: 'white paper',
                title: 'The Intelligent Financial Life™',
                copy: 'Download the white paper that started it all. Bill Crager, Co-Founder and CEO of Envestnet, outlines why meeting consumer demand for an intelligently connected financial life is the future of our industry.',
                url: '/',
                ctaCopy: 'Read Now',
            },
            {
                id: 'card-1',
                image: card1,
                type: 'video',
                title: 'Unlocking the Network Effect',
                copy: 'See the far-reaching opportunities you can unlock for your business by focusing on an Intelligent Financial Life™ for each of your clients—and their network.',
                url: '/',
                ctaCopy: 'Watch Now',
            },
        ],
    },
};
export var TwoCards = function (_a) {
    var className = _a.className, _b = _a.data, title = _b.title, resourceCardList = _b.resourceCardList;
    var customPolygon = "polygon(0 0%, 0 110%, 102% 100%)";
    var _c = useState(0), scrolledBy = _c[0], setScrolledBy = _c[1];
    var _d = useState(0), margin = _d[0], setMargin = _d[1];
    var navigationPrevRef = useRef(null);
    var navigationNextRef = useRef(null);
    var scrollHandler = function (e) {
        var target = e.target;
        var scrollLeft = target.scrollLeft, scrollWidth = target.scrollWidth, clientWidth = target.clientWidth;
        var width = scrollWidth - clientWidth;
        // console.log(scrollLeft, scrollWidth, clientWidth, 'width');
        setScrolledBy((scrollLeft / width) * 100);
    };
    var onBeforeInitHandler = function (swiper) {
        swiper.params.navigation.prevEl = navigationPrevRef.current;
        swiper.params.navigation.nextEl = navigationNextRef.current;
    };
    useEffect(function () {
        var tl = gsap.timeline({
            scrollTrigger: {
                trigger: '.resource-card-carousel-anime',
                start: 'top center',
            },
        });
        tl.to('.resource-card-carousel-anime', {
            autoAlpha: 1,
            duration: 1,
            stagger: {
                each: 0.5,
            },
        });
    });
    return (_jsx("div", { children: _jsx("div", __assign({ className: "card-carousel-section background-section relative w-full snap-center" }, { children: _jsx("div", __assign({ className: "card-carousel card-carousel2 relative w-full  px-0 pb-8" }, { children: _jsx("div", __assign({ className: "resource-card-carousel-anime text-white", onScroll: scrollHandler, style: { visibility: 'hidden' } }, { children: _jsx(Carousel, { title: title, cardsArray: resourceCardList }, void 0) }), void 0) }), void 0) }), void 0) }, void 0));
};
